class FAQEntry extends HTMLElement {
	connectedCallback() {
		const toggleClass = this.getAttribute("toggle");
		this.querySelector("[data-button]").addEventListener("click", () => {
			this.classList.toggle(toggleClass);
		});
	}
}

customElements.define("esc-faq-entry", FAQEntry);
